import btoa from 'btoa';
import client from './client';
import {IDescIdResponse, IDescTtmfResponse} from '@/types/api-responses';

export async function getRlsDescIdByPrepId(id: number) {
    const { data } = await client.GET('/api/v1/public/products/{id}/description-id', {
        params: { path: { id } }
    });
    // Защита от формата ответа: число | объект | массив
    const response = data as unknown as IDescIdResponse[] | IDescIdResponse | number;
    if (typeof response === 'number') return response;
    if (Array.isArray(response)) return response.length > 0 ? response[0].desc_id : 0;
    return response?.desc_id ?? 0;
}

export async function prepDescription(id: number, isPrepId: boolean) {
    try {
        let headers = new Headers();
        headers.set('Authorization', 'Basic ' + btoa('tattehmedfarm' + ":" + '98s12102021'));
        let descId_ = id;
        if (isPrepId) {
            descId_ = await getRlsDescIdByPrepId(id)
        }
        const url = `https://rls-aurora.ru/api/library_solid_description?desc_id=${descId_}&pics_on=1`;
        const response = await fetch(url, {
            credentials: "include",
            headers
        });
        return await response.text();
    } catch (error) {
        return error.toString();
    }
}

export async function prepTtmfDescription(id: number) {
    try {
        const { data } = await client.GET('/api/v1/public/products/{id}/description', {
            params: { path: { id } }
        });
        const response = data as unknown as IDescTtmfResponse[] | IDescTtmfResponse | string;
        if (typeof response === 'string') return response;
        if (Array.isArray(response)) return response.length > 0 ? response[0].html_content : '';
        return response?.html_content ?? '';
    } catch (error) {
        return error.toString();
    }
}